import { routes, authorizedRoutes, unauthorizedRoutes } from '../const';
import { handleRedirect } from '@/utils/redirectHandler';

export const socialLogin = {
  data() {
    return {
      googleParams: {
        client_id: '285868117006-clq0c6p7s565dsnc4ms1j7g7g1r34ljo',
      },
      token: '',
      socialObject: {
        email: '',
        socialLoginType: '',
        token: '',
        socialNetworkId: '',
      },
      defaultErrorMessage:
        'Estado de usuario inválido. Por favor contacta a nuestro soporte.',
    };
  },
  mounted() {
    this.routes = routes;
    this.authorizedRoutes = authorizedRoutes;
    this.unauthorizedRoutes = unauthorizedRoutes;
  },
  methods: {
    logInWithFacebook() {
      window.FB.login(
        response => {
          if (response.status === 'connected') {
            window.FB.api(
              '/me',
              { locale: 'en_US', fields: 'email' },
              userData => {
                const socialObject = {
                  email: userData.email,
                  socialLoginType: 'FACEBOOK',
                  token: response.authResponse.accessToken,
                  socialNetworkId: response.authResponse.userID,
                };
                this.socialLogin(socialObject);
              },
            );
          } else {
            console.log('FB: unauthorized.');
          }
        },
        { scope: 'email' },
      );
    },
    socialLogin(socialObject) {
      this.socialObject = socialObject;

      this.$store.dispatch('register/socialLogin', socialObject).then(resp => {
        if (window.location.href.includes('?debug=log')) {
          console.log('socialLogin resp: ', resp);
        }

        let { userStatus, hasPin, defaultContext } = resp;

        if (userStatus === 'NONE') userStatus = 'CREATE_USER';

        if (userStatus === 'EXTERNAL_REGISTER') {
          console.log('Redirecting to external');
          this.$store.dispatch(
            'register/setRegistrationStep',
            'EXTERNAL_REGISTER',
          );

          this.$router.push('/admin/sign-up/external');
          return;
        }

        setTimeout(() => {
          if (!this.routes.some(r => r === userStatus)) {
            if (this.authorizedRoutes.some(r => r === userStatus)) {
              if (!hasPin) {
                this.$store.dispatch('register/setRegistrationStep', 'SET_PIN');
                setTimeout(() => {
                  this.$router.push({ name: 'SET_PIN' });
                }, 500);
              } else {
                this.handleRedirect(defaultContext);
              }
            } else {
              let error = this.unauthorizedRoutes.find(
                r => r.name === userStatus,
              );
              if (error) {
                this.$toast.error(error.errorMessage);
              } else {
                this.$toast.error(this.defaultErrorMessage);
              }
              setTimeout(() => this.$store.dispatch('logout'), 2000);
            }
          } else {
            this.$store.dispatch('register/setRegistrationStep', userStatus);
            setTimeout(() => this.$router.push({ name: userStatus }), 500);
          }
        }, 500);
      });
    },
    onGoogleSuccess(googleUser) {
      const socialObject = {
        email: googleUser.getBasicProfile().getEmail(),
        token: googleUser.getAuthResponse().id_token,
        socialLoginType: 'GOOGLE',
        socialNetworkId: googleUser.getBasicProfile().getId(),
      };
      this.socialLogin(socialObject);
    },
    onGoogleFailure(err) {
      console.log(err);
    },
    handleRedirect(context) {
      this.$store.dispatch('appLogout');
      this.$router.push({
        name: 'REDIRECT',
        query: {
          redirect: handleRedirect(this.$route.query.redirect, context),
        },
      });
    },
  },
};
